// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3T7vm","errors":"Errors_errors__2zfAe"};